import { useTranslation } from 'react-i18next';
import './StudentProgress.scss';
import '../../OrganizationTables.scss';
import { Students } from 'types/organization/students';
import { TableHead, TableRow, TableCell, TableBody, Table, TablePagination } from '@trackman/web-shared-components';
import { ReactComponent as Checkmark } from 'images/icons/gameFinished.svg';
import { useState } from 'react';
import { TableFooter } from '@mui/material';
import { NoEntriesMatching } from '../../../../../components/NoEntriesMatching/NoEntriesMatching';
import { OrganizationTableInitials } from '../../OrganizationTableInitials/OrganizationTableInitials';

type Props = {
  filteredModuleProgress: Students;
};

export const StudentProgress = ({ filteredModuleProgress }: Props) => {
  const { t } = useTranslation();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const lessonHeaders = filteredModuleProgress[0]?.progressList?.map((lesson) => lesson.lessonName) || [];

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className='organization-table-card-wrapper student-progress-table-wrapper'>
      {filteredModuleProgress.length > 0 ? (
        <Table className='student-progress-table tmu-table'>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell className='student-name'>{t('Name', { ns: 'studentsPage' })}</TableCell>
              {lessonHeaders.map((lessonName) => (
                <TableCell key={lessonName}>{lessonName}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredModuleProgress.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((student) => (
              <TableRow key={student.id}>
                <TableCell>
                  <OrganizationTableInitials name={student.name} />
                </TableCell>
                <TableCell className='student-name'>{student.name}</TableCell>
                {lessonHeaders.map((lessonName) => {
                  const lesson = student.progressList?.find((l) => l.lessonName === lessonName);
                  return (
                    <TableCell key={lessonName}>
                      <ProgressCell
                        progress={Math.round((lesson?.percentage || 0) * 100)}
                        isCertificatePassed={lesson?.isCertificatePassed}
                      />
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                labelRowsPerPage={t('RowsPerPage', { ns: 'general' })}
                count={filteredModuleProgress.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={(e, newPage) => setPage(newPage)}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TableRow>
          </TableFooter>
        </Table>
      ) : (
        <NoEntriesMatching />
      )}
    </div>
  );
};

const ProgressCell = ({ progress, isCertificatePassed }: { progress: number; isCertificatePassed: boolean | undefined }) => {
  return (
    <>
      {(() => {
        if (progress === 0) {
          return <div className='not-started'></div>;
        } else if (isCertificatePassed || progress === 100) {
          return <Checkmark />;
        } else {
          return `${progress}%`;
        }
      })()}
    </>
  );
};
